var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isIE())?_c('b-card',[_c('div',{staticClass:"d-flex align-items-center"},[_c('i',{staticClass:"bi-exclamation-triangle-fill me-3 text-warning"}),_c('span',[_vm._v(" "+_vm._s(_vm.$t('ie.warning'))+" "),_c('router-link',{attrs:{"to":"/ie"}},[_vm._v(" "+_vm._s(_vm.$t('ie.readMore'))+" ")])],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }